import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admanager',
  templateUrl: './admanager.component.html',
  styleUrls: ['./admanager.component.scss']
})
export class AdManagerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
